.ux-iws-e-catalog {
    min-height: 400px;
    display: block;

    &__headline {
        text-align: center;
        margin: 0 auto 50px;
        position: relative;

        @media only screen and (min-width: 768px) {
            margin-bottom: 60px;
        }
    }

    &__results-button-container {
        bottom: 0;
        width: 100%;
        max-height: 44px;
        display: flex;
        align-items: center;
        overflow: visible;
        text-align: center;
        flex-direction: column;

        ux-loader[variant="spinner"] {
            display: flex;
        }

        > *:not(ux-loader[variant="spinner"]) {
            margin: 0 auto;
        }
    }

    &__no-results {
        width: 66%;
        text-align: center;
        margin: 30px auto 20px;

        .ux-text-normal {
            margin: 5px auto;
        }

        @media only screen and (min-width: 1440px) {
            margin-top: 50px;
        }
    }

    &__no-results ux-icon {
        font-size: 100px;

        @media only screen and (min-width: 768px) {
            font-size: 120px;
        }

        @media only screen and (min-width: 1440px) {
            font-size: 150px;
            margin-bottom: -5px;
        }
    }

    &__no-results-button-container {
        margin-top: 30px;
    }

    td:first-child {
        @include font(light);
    }
}
